import { render } from "./metric-object-reference.vue?vue&type=template&id=5003ba1a"
import script from "./metric-object-reference.vue?vue&type=script&lang=js"
export * from "./metric-object-reference.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__